export default __webpack_public_path__ + "media/images/wood-swatches/dark-brown-wood-5b1b271fa58c4a0f6b4a15f3a1b22fa4.png";